import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { TabContent, TabPane } from "reactstrap";
import "component/accountSettings/accountSettings.scss";
import { api } from "api/Api";
import { GET_FACILITY_DATA } from "constants/ApiUrls";
import { useParams } from "react-router-dom";
import { RESPONSE_OK } from "constants/AppConstants";
import NavTabs from "component/common/NavTabs";
const AdminFacilityGeneralInformation = React.lazy(() => import("views/admin/accountSettings/adminFacilitySettings/facilityGeneralSettings"));
const AdminFacilityLoginInformation = React.lazy(() => import("views/admin/accountSettings/adminFacilitySettings/facilityLoginInformation"));
const FacilityRatingSummary = React.lazy(() => import("component/facilityReviews/FacilityRatingSummary"));

function AdminFacilityAccountSetting() {
  const params = useParams();
  
  const [user, setUser] = useState();
  const [loader, setLoader] = useState(false);
  const [resetPasswordModal, setResetPasswordModal] = useState(false);

  // ------ Navtab code start------
    const [currentActiveTab, setCurrentActiveTab] = useState("1");
    const toggle = (tab) => {
      if (currentActiveTab !== tab) setCurrentActiveTab(tab);
    };

    const tabs = [
      { id: "1", label: "General information" },
      { id: "2", label: "Login information" },
      { id: "3", label: "Ratings" },
    ];
  // ------ Navtab code end------

  const getFacilityById = () => {
    setLoader(true);
    setResetPasswordModal(false);

    api(GET_FACILITY_DATA, {}, null, {
      id: params.id,
    }).then((res) => {
      if (res.status === RESPONSE_OK) setUser(res.data.data);
    }).finally(() => {
      setLoader(false);
    });
  };

  useEffect(() => {
    getFacilityById();
  }, []);

  return (
    <>
      <Helmet>
        <title>Purple PRN - Account Settings</title>
      </Helmet>
      <div className="account-settings-main">
        <div className="custom-container">
          <h2>Facility Account</h2>
          
          <NavTabs tabs={tabs} activeTab={currentActiveTab} onToggle={toggle} />

          <TabContent activeTab={currentActiveTab}>
            <TabPane tabId="1">
              <AdminFacilityGeneralInformation
                user={user}
                getFacilityData={getFacilityById}
                resetPasswordModal={resetPasswordModal}
                setResetPasswordModal={setResetPasswordModal}
                loader={loader}
                setLoader={setLoader}
              />
            </TabPane>
            <TabPane tabId="2">
              <AdminFacilityLoginInformation facilityUser={user} />
            </TabPane>
            <TabPane tabId="3">
              {currentActiveTab === "3" && <FacilityRatingSummary facilityId={params.id} />}
            </TabPane>
          </TabContent>
        </div>
      </div>
    </>
  );
}

export default AdminFacilityAccountSetting;
